import React from "react";
import {Link} from "react-router-dom";
import {ZhuangziTitle} from "./Zhuangzi";

function HorsesHooves() {
  return (
      <div className="row">
          <div className="col-md-8 offset-md-2">
              <h1 className="text-center"><Link to="/translation/zhuangzi/horses-hooves">Horse's Hooves</Link></h1>
              <ZhuangziTitle/>
              <div className="text-center">
                  <a href="https://ctext.org/zhuangzi/horsess-hoofs/zh#n2773">Original Text</a>
              </div>
              <hr/>
              <p>
                  A horse's hooves can tread hoarfrost;<br/>
                  its mane withstands wind's chill.
              </p>
              <p>
                  It chews grass, it drinks water;<br/>
                  its feet long for the road.<br/>
                  This is a horse's nature.
              </p>
              <p>
                  It has no use for more,<br/>
                  even for a palace or large tower.
              </p>
              <p>
                  Or so it was, until Bo-le said,<br/>
                  I know how to manage horses&mdash;
              </p>
              <p>
                  brand them<br/>
                  clean them<br/>
                  pare them<br/>
                  halter them<br/>
                  bridle them<br/>
                  hobble them<br/>
                  stable and corral them
              </p>
              <p>
                  (for every dozen,<br/>
                  three died)
              </p>
              <p>
                  fast them<br/>
                  thirst them<br/>
                  gallop them<br/>
                  trot them<br/>
                  order them<br/>
                  align them
              </p>
              <p>
                  ahead the peril of bit and breastplate,<br/>
                  behind the might of whip and switch
              </p>
              <p>
                  (more than half died)
              </p>
              <p>
                  The potter said,<br/>
                  I know how to manage clay&mdash;
              </p>
              <p>
                  form circles like a compass,<br/>
                  squares like a carpenter's square.
              </p>
              <p>
                  The carpenter said,<br/>
                  I know how to manage wood&mdash;
              </p>
              <p>
                  bend it with hooks,<br/>
                  straighten it with cords.
              </p>
              <p>
                  But is it the nature of wood and clay<br/>
                  to need regulation with ropes and hooks?
              </p>
              <p>
                  Yet through the ages<br/>
                  Bo-le is called the expert on horses,<br/>
                  potters and carpenters are called<br/>
                  the experts on clay and wood.
              </p>
              <p>
                  Those who govern the land:<br/>
                  this is also your mistake!
              </p>
              <p>
                  <strong>莊子，“馬蹄” <br/> (Zhuangzi, "Horse's Hooves")</strong>
              </p>
              <p>
                  <em>Trans. Porter James, 2024-01-06</em>
              </p>
          </div>
      </div>
  )
}

export default HorsesHooves;
